module.exports = __webpack_public_path__ + "img/insta-link.87d10182.png";